import colors from '@/configs/colors.json'

export default (key) => {
  return colors[key] || '#ff0000'
}
